import { render } from "./RegisterOrUploadIso.vue?vue&type=template&id=2c4187f1&scoped=true"
import script from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"
export * from "./RegisterOrUploadIso.vue?vue&type=script&lang=js"

import "./RegisterOrUploadIso.vue?vue&type=style&index=0&id=2c4187f1&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4187f1"]])

export default __exports__